let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bVaXi")).then(() => parcelRequire('26MMP'));